/**
 * Task Reference Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String}
 */
window.taskReferenceFormatter = function(value, row) {
    let html = '';
    if (typeof row.reference === "undefined" || row.reference === null) {
        return '';
    }
    html += '<span class="badge badge-pill badge-reference">';
    if (typeof row.reference_url !== "undefined" && row.reference_url !== null) {
        html += '<a href="'+row.reference_url+row.code+'" target="_blank" rel="nofollow">';
        html += row.reference;
        html += '</a>';
    } else {
        html += row.reference;
    }
    html += '</span>';
    return html;

};
